import React, { Component } from 'react';
import AuthService from '../../utils/AuthService';
import Page from '../Page';
import PageSection from '../PageSection';
import Table from '../Table';
import UserRoleSelect from '../UserRoleSelect';

var Auth = new AuthService();

class ManageUsers extends Component {
	constructor(props) {
		super(props);

		this.state = {
			tableHeader: ['User ID', 'Name', 'Email Address', 'Phone', 'User Role'],
			tableBody: []
		}

		this.Auth = new AuthService();
		this.Auth.fetch('/pp-users')
			.then((result) => {
				var row = [],
					body = [];

				if (result.success === true) {
					for (let a = 0; a < result.users.length; a += 1) {
						row = [];
						row.push(result.users[a].pp_user_id);
						row.push(result.users[a].first_name + ' ' + result.users[a].last_name);
						row.push(result.users[a].pp_user_email);
						row.push(result.users[a].phone);
						row.push(<UserRoleSelect role={result.users[a].pp_role_name} userID={result.users[a].pp_user_id} />);
						body.push(row);
					}
					this.setState({
						tableBody: body
					})
				} else {
					alert(result.message);
				}
			});
	}
	render() {

		let loadingText = <p className="pp-loading">Loading Users</p>;

		return (
			<Page pageTitle="Manage Users" pageClass="pp-manage-users-page">

				<PageSection>
					<Table
						tableHeading={this.state.tableHeader}
						tableBody={this.state.tableBody}
						noResultsMessage={loadingText}
					/>
				</PageSection>

			</Page>
		);
	}
}

export default ManageUsers;



// WEBPACK FOOTER //
// ./src/components/pages/ManageUsers.js